import { TabList, TabListProps } from "@mui/lab";
import { styled, tabClasses, tabsClasses } from "@mui/material";

const StyledTabList = styled((props: TabListProps) => <TabList {...props} />)(
  ({ theme }) => ({
    position: "sticky",
    top: "0",
    zIndex: "2",
    padding: "0 16px",
    backgroundColor: theme.palette.common.white,
    boxShadow: "0px 1px 2px 0px #0000000F",
    [`& .${tabsClasses.list}`]: {
      [`& .${tabClasses.selected}`]: {
        color: theme.palette.primary.main,
      },
    },
    [`& .${tabsClasses.indicator}`]: {
      height: "3px",
      backgroundColor: theme.palette.primary.main,
      borderTopLeftRadius: "3px",
      borderTopRightRadius: "3px",
    },
  })
);

export default StyledTabList;
